import { render } from "./InformationAndActions.vue?vue&type=template&id=12d68310&scoped=true"
import script from "./InformationAndActions.vue?vue&type=script&lang=js"
export * from "./InformationAndActions.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-12d68310"

export default script